import { render, staticRenderFns } from "./AnalizIcon.vue?vue&type=template&id=66ede676&scoped=true"
import script from "./AnalizIcon.vue?vue&type=script&lang=js"
export * from "./AnalizIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ede676",
  null
  
)

export default component.exports